import api from "../../utils/api";
import { USER_URL } from "../../utils/endpoints";
import { User } from "../../types/User/User";
import { PaginationValues } from "../../types/General/PaginationValues";

export async function getUsers(
  id?: string,
  filterValues?: any,
  paginationValues?: PaginationValues,
) {
  try {
    const response = await api.get(id ? `${USER_URL}/${id}` : USER_URL, {
      params: {
        ...filterValues,
        ...paginationValues,
      },
    });
    const data: User[] = id
      ? response.data
      : response.data.result.map((option: User) => ({
          id: option.id,
          email: option.email,
          isActive: option.isActive,
          name: option.name,
          organization: option.organization ?? null,
          phoneNumber: option.phoneNumber ?? null,
          position: option.position ?? null,
          roles: option.roles,
          userProvince: option.userProvince ?? null,
          userCounty: option.userCounty ?? null,
          allowReceiveAlerts: option.allowReceiveAlerts,
          partner: option.partner ?? null,
        }));

    return { content: data, totalItems: response.data.totalItems };
  } catch (error) {
    throw error;
  }
}
